export default __webpack_public_path__ + "static/scooter-ac88b1d532c8f451a288e141ec5416bc.png";